import React from 'react';
import img1 from '../../images/techscoreblog.jpg'

function BlogCardTechScore() {
    return (
        <div className="group h-full overflow-hidden bg-white border border-gray-200 rounded-lg transition-shadow duration-300 hover:shadow-xl">
            <a href="https://blog.techscore.com/entry/2023/04/14/080000" target="_blank" rel="noopener noreferrer">
                {/* ゆっくりズームするサムネイル */}
                <div className="overflow-hidden rounded-lg">
                    <img
                        className="object-cover w-full h-40 rounded-lg transition-transform duration-700 ease-out-expo group-hover:scale-110"
                        src={img1}
                        alt=""
                    />
                </div>
                <div className="p-5">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">オブジェクト指向におけるデザインパターンについて</h5>
                    <p className="mb-3 font-normal text-gray-700">この記事ではデザインパターンとは何か、デザインパターンを使うメリット、kotlinを使った実際のプログラム例を紹介します。
                        オブジェクト指向におけるデザインパターンについて - TECHSCORE BLOG</p>
                    <div className="bounce-hover inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800">
                        Read more
                        <svg aria-hidden="true" className="w-4 h-4 ml-2 -mr-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path></svg>
                    </div>
                </div>
            </a>
        </div>
    );
}
export default BlogCardTechScore;